import React from 'react'
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import placeholderHelper from "../../helpers/PlaceholderHelper";
import Row from "reactstrap/es/Row";
import dateHelpers from "../../helpers/DateHelper";

let resourceStrings = new LocalizedStrings(resource_strings);

const FeedbackItem = (props) => {

    function clientIcon() {
        return (
            <a
                className="avatar mr-3"
                onClick={e => e.preventDefault()}
            >
                <img
                    alt="..."
                    style={{objectFit: "cover", imageOrientation: "from-image"}}
                    src={props.item.client_photo ? props.item.client_photo : placeholderHelper.randomIcon()}
                />
            </a>)
    }

    function renderStars() {
        if (props.item.rating) {
            return (
                <>
                    {[...Array(props.item.rating)].map((i, index) => {
                        return (
                            <img
                                key={index}
                                alt="..."
                                width={12}
                                className="mr-2"
                                height={12}
                                src={require("assets/img/icons/common/star.svg").default}/>
                        )
                    })}
                </>
            )
        }
    }

    function clientName() {
        return props.item.client_name ? props.item.client_name : ""
    }

    localize();

    function yclassName() {
        return props.item.yclass.name + " " + dateHelpers.formatDate(new Date(props.item.yclass.date))
    }

    function goToClass(e) {
        // props.goToClass(e, props.item)
    }

    return (
        <tr>
            <td style={{width: 3, paddingRight: 0, verticalAlign: "middle"}}>
                {clientIcon()}
            </td>
            <td className="overflow-visible" style={{verticalAlign: "middle"}}>
                {props.item.yclass &&
                <Row style={{justifyContent: "center", fontSize: "0.6rem", color: "#0f76d0"}} onClick={e => goToClass(e)}>
                    {yclassName()}
                </Row>
                }
                <Row style={{justifyContent: "center"}}>
                    <b>
                        {clientName()}
                    </b>
                </Row>
                <Row style={{justifyContent: "center"}}>
                    {renderStars()}
                </Row>
            </td>
            <td className="align-items-center" style={{
                verticalAlign: "middle",
                whiteSpace: "unset",
                overflowWrap: "break-word",
                maxWidth: 500,
                wordBreak: "break-all"
            }}>{props.item.comment}</td>
        </tr>
    )

    function localize() {
        const loc = localeHelpers.currentLocale();
        resourceStrings.setLanguage(loc);
    }
}

export default FeedbackItem;

